// Affordable Support Tools Component JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Initialize the component
  initAffordableSupportTools();
});

function initAffordableSupportTools() {
  // Handle add to cart buttons from product-block.liquid
  const productBlockButtons = document.querySelectorAll('.affordable-support-tools .product-block .add_to_cart_btn');
  productBlockButtons.forEach(button => {
    button.addEventListener('click', handleProductBlockAddToCart);
  });
  
  // Handle add to cart buttons from fallback placeholder products
  const fallbackButtons = document.querySelectorAll('.affordable-support-tools .add-to-cart-btn');
  fallbackButtons.forEach(button => {
    button.addEventListener('click', handleFallbackAddToCart);
  });
  
  // Add hover effects for product images
  const productImages = document.querySelectorAll('.affordable-support-tools .product-block .image-cont img, .affordable-support-tools .placeholder-image img');
  productImages.forEach(img => {
    img.addEventListener('mouseenter', handleImageHover);
    img.addEventListener('mouseleave', handleImageHoverOut);
  });
  
  // Initialize product set images if they exist
  initProductSetImages();
}

function initProductSetImages() {
  const productSets = document.querySelectorAll('.affordable-support-tools .product-set');
  
  productSets.forEach(set => {
    const images = set.querySelectorAll('img');
    if (images.length > 1) {
      // Add staggered animation delay for set items
      images.forEach((img, index) => {
        img.style.animationDelay = `${index * 0.1}s`;
      });
    }
  });
}

function handleProductBlockAddToCart(event) {
  const button = event.currentTarget;
  const productBlock = button.closest('.product-block');
  const productId = productBlock.getAttribute('data-product-id');
  const productTitle = productBlock.querySelector('.product-block__title')?.textContent?.trim() || 'Product';
  const productPrice = productBlock.querySelector('.product-price')?.textContent?.trim() || '';
  
  // Add loading state
  const originalText = button.querySelector('.button-actual-text')?.textContent || button.textContent;
  button.innerHTML = '<span class="button-actual-text">Adding...</span>';
  button.disabled = true;
  
  // Simulate API call delay (replace with actual cart API call)
  setTimeout(() => {
    // Show success message
    showNotification(`Added ${productTitle} to cart!`, 'success');
    
    // Reset button
    button.innerHTML = originalText;
    button.disabled = false;
    
    // Add visual feedback
    button.style.background = '#28a745';
    setTimeout(() => {
      button.style.background = '';
    }, 1000);
    
    // Track the add to cart event (for analytics)
    trackAddToCart(productId, productTitle, productPrice);
    
  }, 1000);
}

function handleFallbackAddToCart(event) {
  const button = event.currentTarget;
  const productName = button.closest('.product-item').querySelector('.product-name').textContent;
  const productPrice = button.querySelector('.btn-price').textContent;
  
  // Add loading state
  const originalText = button.innerHTML;
  button.innerHTML = '<span class="btn-text">Adding...</span>';
  button.disabled = true;
  
  // Simulate API call delay (replace with actual cart API call)
  setTimeout(() => {
    // Show success message
    showNotification(`Added ${productName} to cart!`, 'success');
    
    // Reset button
    button.innerHTML = originalText;
    button.disabled = false;
    
    // Add visual feedback
    button.style.background = '#28a745';
    setTimeout(() => {
      button.style.background = '#3b55fb';
    }, 1000);
    
    // Track the add to cart event (for analytics)
    trackAddToCart('fallback', productName, productPrice);
    
  }, 1000);
}

function handleImageHover(event) {
  const img = event.target;
  img.style.transform = 'scale(1.05)';
  img.style.transition = 'transform 0.2s ease';
}

function handleImageHoverOut(event) {
  const img = event.target;
  img.style.transform = 'scale(1)';
}

function trackAddToCart(productId, productName, productPrice) {
  // Track add to cart event for analytics
  if (typeof gtag !== 'undefined') {
    gtag('event', 'add_to_cart', {
      'currency': 'GBP',
      'value': parseFloat(productPrice.replace(/[£,]/g, '')) || 0,
      'items': [{
        'item_id': productId || 'unknown',
        'item_name': productName,
        'price': parseFloat(productPrice.replace(/[£,]/g, '')) || 0,
        'currency': 'GBP'
      }]
    });
  }
  
  // Also track with Facebook Pixel if available
  if (typeof fbq !== 'undefined') {
    fbq('track', 'AddToCart', {
      content_name: productName,
      content_category: 'Affordable Support Tools',
      value: parseFloat(productPrice.replace(/[£,]/g, '')) || 0,
      currency: 'GBP'
    });
  }
}

function showNotification(message, type = 'info') {
  // Remove existing notifications first
  const existingNotifications = document.querySelectorAll('.notification');
  existingNotifications.forEach(notification => notification.remove());
  
  // Create notification element
  const notification = document.createElement('div');
  notification.className = `notification notification--${type}`;
  notification.innerHTML = `
    <div class="notification__content">
      <span class="notification__message">${message}</span>
      <button class="notification__close" onclick="this.parentElement.parentElement.remove()">×</button>
    </div>
  `;
  
  // Add styles
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${type === 'success' ? '#28a745' : '#17a2b8'};
    color: white;
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 1000;
    max-width: 300px;
    animation: slideInRight 0.3s ease-out;
  `;
  
  // Add to page
  document.body.appendChild(notification);
  
  // Auto remove after 3 seconds
  setTimeout(() => {
    if (notification.parentElement) {
      notification.remove();
    }
  }, 3000);
}

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  .notification__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
  
  .notification__message {
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 500;
  }
  
  .notification__close {
    background: none;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s ease;
  }
  
  .notification__close:hover {
    background: rgba(255,255,255,0.2);
  }
  
  /* Enhanced animations for product sets */
  .product-set img {
    animation: fadeInUp 0.4s ease-out both;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

document.head.appendChild(style);
